module.exports = __webpack_public_path__ + "static/media/image1.2e652189.png";